module.exports = __webpack_public_path__ + "static/img/logo-icon.14ad8794.jpeg";